<template>
    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H5V11L0 6.76923V0Z" fill="#E86600" />
        <path d="M8 0H13V11L8 6.76923V0Z" fill="#E86600" />
    </svg>
</template>
